module.exports = __webpack_public_path__ + "img/icon_map_hsjssh_c.7a2eef95.png";